/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import { theme as motiliTheme } from '@motili/ui';
import { components } from './components';

/**
 * Custom theme extending @motili/ui theme with app-specific overrides.
 */
export const theme = {
    ...motiliTheme,
    components,
};

export type CustomTheme = typeof theme;
